(ns frontend.ux-overhaul.components.select-with-filter.view
  (:require
   ["react-select" :as react-select :refer [components] :default Select]
   [clojure.string :as string]
   [frontend.ui.component.accordion.view :refer [accordion-single]]
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn adapt
  [component]
  (try
    (r/adapt-react-class component)
    (catch js/Object e
      (prn (.-message e)))))

(def select (adapt Select))

(def option (adapt (.-Option components)))


(defn group-heading-style
  []
  {:height       "50px"
   :width        "300px"
   :display      "flex"
   :align-items  "center"
   :padding-left "10px"
   :font-weight  600})
(defn option-style
  [focused?]
  ^{:pseudo {:hover {:background (if focused? "#8ABF4C" "rgba(0,0,0,0.05)")
                     :color      (when focused? "white")}}}
  {:height       "50px"
   :width        "300px"
   :display      "flex"
   :cursor       "pointer"
   :align-items  "center"
   :padding-left "20px"
   :background   (when focused? "#8ABF4C")
   :color        (when focused? "white")})


(defn group-heading
  [{:keys [state-atom on-select-option!
           on-change!
           options]} js-args]
  (let [{:keys [data]} (js->clj js-args :keywordize-keys true)
        group-label (:label data)

        group-index (:index data)

        group-data (->> options
                        (filter (fn [group]
                                  (= (:index group) group-index)))
                        first)

        visible-options (->> group-data
                             :options
                             (filterv (fn [option]
                                        (let [search-term (:search-term @state-atom)]
                                          (if (or (not search-term)
                                                  (= (count search-term) 0))
                                            true
                                            (string/includes? (string/lower-case (:label option)) search-term)))))
                             (map (fn [opt]
                                    (let [{:keys [value label]} opt]
                                      ^{:key (str "option-" value)}
                                      [:div
                                       {:on-click (fn []
                                                    (on-select-option!)
                                                    (on-change! opt))}
                                       label])))
                             (doall))]
    (r/as-element
     (when (not= (count visible-options) 0)
       [accordion-single
        {:title      group-label
         :content    [:div visible-options]
         :expanded?  (get-in @state-atom [:expanded group-index])
         :index      group-index
         :state-atom state-atom}]))))

;#8ABF4C
(def styles
  {:control (fn [base _state]
              (js/console.log "base " base)
              base)})

(defn custom-menu-list
  [{:keys [list-items on-select-option!]} js-args]
  (let [js-focused-option (.-focusedOption js-args)

        focused-option (js->clj js-focused-option :keywordize-keys true)

       ]
    (r/as-element
     [:div
      {:style {:height "300px"}}
      (r/as-element
       (into
        [:> js/ReactVirtualized.List
         {:class-name         "zap-grid__header"
          :row-renderer       (fn [js-args]
                                (let [args (js->clj js-args :keywordize-keys true)
                                      {:keys [index style]} args
                                      item (nth list-items index)
                                      render-type (:render-type item)
                                      label (:label item)
                                      _focused? (= (:value-keyword-str focused-option)
                                                   (:value-keyword-str item))]
                                  (r/as-element
                                   [:div
                                    {:style style}
                                    (if (= render-type :group-heading)
                                      [:div
                                       {:class ""}
                                       label]
                                      [:div
                                       {:class    ""
                                        :on-click #(on-select-option! item)}
                                       label])])))
          :column-width       300
          :column-count       1
          :width              300
          :height             300
          :overscan-column-count 1
          :row-height         50
          :overscan-row-count 2
          :row-count          (count list-items)
          :ref                (fn [_args]
                                  ;; todo: save grid ref?
                              )}]))])))
(defn view
  "props:

   groups: [{:label string :options [{:key string :label string}]}]

   state-atom: atom

   value-kw: keyword

   on-change!
  "
  [{:keys [groups state-atom value-kw on-change!]}]
  (let [; Todo - these are temporary
        section-accordions? false
        virtualized? true

        local-state (r/atom {:menu-open?  false
                             :ref         nil
                             :search-term ""})

        search-timeout-atom (r/atom nil)

        expand-all! #(->> groups
                          (map-indexed (fn [index _]
                                         (swap! local-state assoc-in [:expanded index] true)))
                          (doall))

        collapse-all! #(swap! local-state dissoc :expanded)

        on-select-option! (fn [option]
                            (on-change! option)
                            (when-let [ref (:ref @local-state)]
                              (.blur ref))
                            (swap! local-state dissoc :expanded))

        options (->> groups
                     (map-indexed (fn [index group]
                                    (assoc group :index index)))
                     (vec)
                     (doall))

        get-value (fn [value]
                    (let [option-values (->> options
                                             (mapcat :options)
                                             vec)
                          matches (->> option-values
                                       (filter (fn [option]
                                                 (= (:value option) value))))]
                      (if (= (count matches) 0)
                        nil
                        (first matches))))

        filter-option (fn [_option search-term]
                        (js/console.log "filter option " search-term)
                        (if (= (count (js->clj search-term)) 0)
                          (collapse-all!)
                          (expand-all!))
                        (let [search-lower (.toLowerCase search-term)]
                          (swap! local-state assoc :search-term search-lower)))

        filter-option-virtualized (fn [option search-term]
                                    (let [search-lower (.toLowerCase search-term)
                                          option-label-lower (.toLowerCase (.-label option))
                                          prev-search-timeout @search-timeout-atom]

                                      (when prev-search-timeout
                                        (js/clearTimeout prev-search-timeout)
                                        (reset! search-timeout-atom nil))

                                      (let [search-timeout (fu/timeout 700
                                                                       (fn []
                                                                         (js/console.log "activate search")
                                                                         (swap! local-state assoc :search-term search-lower)
                                                                         (reset! search-timeout-atom nil)))]
                                        (reset! search-timeout-atom search-timeout))

                                      (.includes option-label-lower search-lower)))]
    (fn []
      (let [value-from-state (get @state-atom value-kw)
            value (get-value value-from-state)

            list-items (->> options
                            (mapcat (fn [{:keys [label options]}]
                                      (-> [{:label       label
                                            :render-type :group-heading}]
                                          (concat (->> options
                                                       (map (fn [opt]
                                                              (merge opt
                                                                     {:render-type :option}))))))))
                            (filter (fn [{:keys [label render-type]}]
                                      (if (= render-type :group-heading)
                                        true
                                        (let [search-term (:search-term @local-state)
                                              label-lower-js (.toLowerCase (clj->js label))
                                              match? (.includes label-lower-js search-term)]
                                          match?))))
                            (doall))]
        [:div
         [select
          (merge
           {:value    value
            :options  options
            :onChange on-change!
            :styles   {:control      (fn [base _state]
                                       (let [green "#8ABF4C"
                                             clj-styles (js->clj base :keywordize-keys true)

                                             clj-state (js->clj _state :keywordize-keys true)
                                             is-focused? (:isFocused clj-state)

                                             clj-styles (merge
                                                         clj-styles
                                                         (when is-focused?
                                                           {:borderColor green
                                                            :boxShadow   (str "0 0 0 1px " green)
                                                            :&:hover     {:borderColor green}}))
                                             js-styles (clj->js clj-styles)]
                                         js-styles))
                       :groupHeading (fn [base _]
                                       (let [clj-styles (js->clj base :keywordize-keys true)
                                             clj-styles (merge
                                                         clj-styles
                                                         {:fontWeight 600
                                                          :color      "#3b3b3b"})
                                             js-styles (clj->js clj-styles)]
                                         js-styles))}
            :ref      (fn [ref]
                        (when ref
                          (swap! local-state assoc :ref ref)))}
           (when section-accordions?
             {:components   {:GroupHeading (partial group-heading
                                                    {:state-atom        local-state
                                                     :on-select-option! on-select-option!
                                                     :on-change!        on-change!
                                                     :options           options})
                             :Option       (fn [] (r/as-element [:div nil]))}
              :filterOption filter-option
              :onBlur       #(swap! local-state dissoc :expanded)})
           (when (and virtualized? (not section-accordions?))
             {:components   {:MenuList (partial custom-menu-list
                                                {:list-items        list-items
                                                 :on-select-option! on-select-option!})}
              :filterOption filter-option-virtualized}))]
        ]))))
